import PropTypes from 'prop-types';

import { DimensionPropType } from './dimension';
import { PackagePropType } from './package';
import { WeightPropType } from './weight';

export const RateBrowserShipmentConfigurationPropType = PropTypes.shape({
  shipFromId: PropTypes.string,
  shipToCountryCode: PropTypes.string.isRequired,
  shipToPostalCode: PropTypes.string.isRequired,
  shipToCityOrSuburb: PropTypes.string,
  shipToCity: PropTypes.string,
  weight: PropTypes.oneOfType([
    WeightPropType,
    PropTypes.shape({
      weightUnit: PropTypes.string,
      weight: PropTypes.number,
    }),
  ]),
  dimensions: DimensionPropType,
  packageTypeId: PropTypes.string,
  isResidential: PropTypes.bool,
  confirmationType: PropTypes.string,
  selectedPackage: PackagePropType,
  packageId: PropTypes.string,
});

/**
 * @typedef {object} RateBrowserShipmentConfigurationWeight
 * @property {string} weightUnit
 * @property {number} weight
 */

/**
 * @typedef {object} RateBrowserShipmentConfigurationPropType
 * @property {string} shipFromId
 * @property {string} shipToCountryCode
 * @property {string} shipToPostalCode
 * @property {string} shipToCityOrSuburb
 * @property {string} shipToCity
 * @property {RateBrowserShipmentConfigurationWeight|WeightPropType} weight
 * @property {DimensionPropType} dimensions
 * @property {string} packageTypeId
 * @property {boolean} isResidential
 * @property {string} confirmationType
 * @property {PackagePropType} selectedPackage
 * @property {string} packageId
 */
